import DashboardManager from './dashboard-manager';

export default DashboardManager;
